enum LicenseFeature {
    DEFAULT = 'default',
    ADVANCED = 'advanced',
    TECHNICAL = 'technical',
    REPORTING = 'report',
    BENCHMARKING = 'benchmark',
    ALERTING = 'alert',
    PROGNOSIS = 'prognosis',
    ACCOUNTING = 'accounting',
    REIMPORT = 'reimport',
    PLANDATA_IMPORT = 'plandataimport',
}

function licenseFeatureFromString(representation: string): LicenseFeature|undefined {
    switch (representation) {
        case 'default': return LicenseFeature.DEFAULT;
        case 'advanced': return LicenseFeature.ADVANCED;
        case 'technical': return LicenseFeature.TECHNICAL;
        case 'report': return LicenseFeature.REPORTING;
        case 'benchmark': return LicenseFeature.BENCHMARKING;
        case 'alert': return LicenseFeature.ALERTING;
        case 'prognosis': return LicenseFeature.PROGNOSIS;
        case 'accounting': return LicenseFeature.ACCOUNTING;
        case 'reimport': return LicenseFeature.REIMPORT;
        case 'plandataimport': return LicenseFeature.PLANDATA_IMPORT;
        default: return undefined;
    }
}

export {
    licenseFeatureFromString,
    LicenseFeature,
};

export default LicenseFeature;
